import { onMounted, onUnmounted, type Ref, readonly, ref } from 'vue';

/**
 * Un « maintenant » réactif, partagé par toute l'application.
 *
 * Une page de debug affiche facilement cinquante dates relatives : un timer par
 * composant, ce sont cinquante réveils par minute pour la même information.
 * Ici, un seul intervalle, compté par référence — il démarre au premier
 * composant monté et s'arrête au dernier démonté (sinon un test qui monte un
 * composant laisse un timer ouvert et Vitest ne rend jamais la main).
 */

const now = ref(Date.now());
let subscribers = 0;
let timer: ReturnType<typeof setInterval> | undefined;

const DEFAULT_INTERVAL_MS = 30_000;

export function useNow(intervalMs: number = DEFAULT_INTERVAL_MS): Readonly<Ref<number>> {
  onMounted(() => {
    subscribers += 1;
    if (timer === undefined) {
      now.value = Date.now();
      timer = setInterval(() => {
        now.value = Date.now();
      }, intervalMs);
    }
  });

  onUnmounted(() => {
    subscribers -= 1;
    if (subscribers <= 0 && timer !== undefined) {
      clearInterval(timer);
      timer = undefined;
      subscribers = 0;
    }
  });

  return readonly(now);
}
